<template>
  <main class="main contacts max-width">
		<h1 class="title-medium centered regular">Contatti</h1>
		<p class="title-medium centered light">
			<span>Tel: 02/4452664</span>
			<span><a href="mailto:edizionicaramba@caramba.it">edizionicaramba@caramba.it</a></span>
		</p>
		<p class="title-medium centered light">
			<span>Edizioni Caramba S.r.l.</span>
			<span>Via Ettore Romagnoli, 7</span>
			<span>Milano, 20146</span>		
		</p>
	</main>
</template>

<script>
export default {
  name: 'Contatti',

  mounted() {
    document.title = 'Caramba - Contatti';
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/components/Contatti.vue